import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appReplaceComma]',
})
export class ReplaceCommaDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const transformed = value.replace(/,/g, '.');
    this.ngControl.control!.setValue(transformed, { emitEvent: true });
  }
}
